import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';

const GoogleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
);

const AuthModal = ({ open, onClose }) => {
  const { startGoogleLogin } = useAuth();
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-emerald-950">Welcome to CalorieSnap</DialogTitle>
          <DialogDescription>Start your 1-day free trial with 3 free scans. No credit card needed.</DialogDescription>
        </DialogHeader>
        <div className="pt-2">
          <Button onClick={startGoogleLogin} className="w-full h-12 bg-white text-emerald-950 border border-emerald-950/10 hover:bg-emerald-50 rounded-full font-medium">
            <GoogleIcon /> <span className="ml-3">Continue with Google</span>
          </Button>
          <p className="text-xs text-emerald-950/50 text-center mt-4">By continuing you agree to our Terms and Privacy Policy.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
